import { Button, Input, TableCell, TableRow } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import * as React from "react";
import { ItemSelect } from "../../../../components/ItemSelect";

export interface IPackItem {
    itemId: string | number;
    amount: number;
    level: number;
    premiumValue: number;
}

export interface IPackItemWithId extends IPackItem {
    id: string;
}

interface PackItemProps {
    entry: IPackItemWithId;

    onRemove(item: IPackItemWithId);

    onUpdate(item: IPackItemWithId);
}

export class PackItem extends React.Component<PackItemProps, IPackItemWithId> {
    state = {
        id: this.props.entry.id,
        itemId: this.props.entry.itemId,
        amount: this.props.entry.amount,
        level: this.props.entry.level,
        premiumValue: this.props.entry.premiumValue,
    };

    onValueChange = (key: keyof IPackItem, value: any) => {
        this.setState(state => {
            let parsedValue = +value;
            if (isNaN(parsedValue)) {
                parsedValue = value;
            }

            // @ts-ignore
            state[key] = parsedValue;

            return state;
        }, () => {
            this.props.onUpdate(this.state);
        });
    };

    remove = () => {
        if (!confirm("Are you sure you want to remove this Item?")) {
            return;
        }

        this.props.onRemove(this.state);
    };

    render() {
        return <TableRow
            key={this.state.id}
            hover={true}
        >
            <TableCell>
                <ItemSelect label={"Item"} value={this.state.itemId}
                            onChange={(_e, id) => this.onValueChange("itemId", id)}/>
            </TableCell>
            <TableCell>
                <Input type="number" value={this.state.amount}
                       onChange={(e) => this.onValueChange("amount", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Input type="number" value={this.state.level}
                       onChange={(e) => this.onValueChange("level", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Input type="number" value={this.state.premiumValue}
                       onChange={(e) => this.onValueChange("premiumValue", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Button disableElevation onClick={this.remove}>
                    <DeleteForeverIcon color={"error"}/>
                </Button>
            </TableCell>
        </TableRow>;
    }
}
